module.exports = __webpack_public_path__ + "static/media/gift-pile-alt.6e5c20b2.svg";